import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownProps {
  content: string;
  className?: string;
}

// 不渲染原始 HTML（react-markdown 默认就不渲染），链接一律新窗口打开
export const Markdown: React.FC<MarkdownProps> = ({ content, className = '' }) => (
  <div className={`text-sm text-gray-700 leading-relaxed break-words ${className}`}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => <h1 className="text-lg font-semibold text-gray-900 mt-4 mb-2 first:mt-0">{children}</h1>,
        h2: ({ children }) => <h2 className="text-base font-semibold text-gray-900 mt-4 mb-2 first:mt-0">{children}</h2>,
        h3: ({ children }) => <h3 className="text-sm font-semibold text-gray-800 mt-3 mb-1 first:mt-0">{children}</h3>,
        h4: ({ children }) => <h4 className="text-sm font-medium text-gray-800 mt-3 mb-1 first:mt-0">{children}</h4>,
        p: ({ children }) => <p className="my-2 first:mt-0 last:mb-0">{children}</p>,
        ul: ({ children }) => <ul className="list-disc pl-5 my-2 space-y-1">{children}</ul>,
        ol: ({ children }) => <ol className="list-decimal pl-5 my-2 space-y-1">{children}</ol>,
        li: ({ children }) => <li className="pl-0.5">{children}</li>,
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{children}</a>
        ),
        blockquote: ({ children }) => (
          <blockquote className="border-l-4 border-gray-200 pl-3 my-2 text-gray-500">{children}</blockquote>
        ),
        hr: () => <hr className="my-4 border-gray-200" />,
        // 行内代码 / 代码块：react-markdown 9 里块级代码带 language-xxx 类，或位于 pre 内
        code: ({ className: cls, children }) =>
          /language-/.test(cls || '') ? (
            <code className={`${cls} font-mono text-xs`}>{children}</code>
          ) : (
            <code className="px-1 py-0.5 rounded bg-gray-100 text-gray-800 font-mono text-xs">{children}</code>
          ),
        pre: ({ children }) => (
          <pre className="my-2 p-3 rounded-md bg-gray-900 text-gray-100 overflow-x-auto text-xs leading-relaxed">{children}</pre>
        ),
        table: ({ children }) => (
          <div className="my-2 overflow-x-auto">
            <table className="min-w-full text-xs border border-gray-200">{children}</table>
          </div>
        ),
        th: ({ children }) => <th className="border border-gray-200 bg-gray-50 px-2 py-1 text-left font-medium">{children}</th>,
        td: ({ children }) => <td className="border border-gray-200 px-2 py-1">{children}</td>,
        // 截图限高，点开看原图
        img: ({ src, alt }) => (
          <a href={src} target="_blank" rel="noopener noreferrer" className="inline-block my-2">
            <img src={src} alt={alt} loading="lazy" className="max-w-full max-h-96 rounded-md border border-gray-200 hover:border-blue-300" />
          </a>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);
